import styled from "styled-components";

export const EditResellerStyle = styled.div`
  .input-div {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-family: light-pro, sans-serif;
  }

  .input-field {
    height: 4vh;
    margin-bottom: 5px;
    width: 80%;
    font-family: light-pro, sans-serif;
    font-size: 15px;
    :focus {
      border-color: white;
      box-shadow: 0 0 5px #f7951d;
    }
  }
  .bootstrap-btn {
    font-family: medium-pro, sans-serif !important;
    margin-bottom: 0;
  }
  .error-input {
    height: 4vh;
    margin-bottom: 5px;
    font-family: light-pro, sans-serif;
    border-color: red;
    width: 80%;
  }

  .add-icon {
    font-size: 23px;
    color: #f28809;
    margin-right: 10px;
  }

  .disable-icon {
    pointer-events: none;
    color: #bcb7b7;
  }

  .add-button {
    width: 50px;
    background-color: hsl(33, 93%, 54%);
    border-color: white;
    color: white;
    font-family: medium-pro, sans-serif;
    justify-content: center;
    font-size: 15px;
    padding: 10px 0;
  }

  .text-error {
    font-family: light-pro, sans-serif;
    color: red;
    font-size: 14px;
    margin-left: 2px;
    margin-bottom: 0;
  }

  .text-login {
    margin-top: 5px;
    font-family: medium-pro, sans-serif;
  }

  .modal-header2 {
    text-align: center;
    margin-bottom: 25px;
    font-weight: 500;
    font-family: medium-pro, sans-serif;
  }

  .line {
    background-color: gray;
    height: 1px;
    width: 100%;
    margin-bottom: 20px;
    opacity: 0.3;
  }

  .loading-div {
    margin-top: 5px;
    font-family: light-pro, sans-serif;
    text-align: center;
    font-weight: 700;
  }
`;
